import * as React from 'react';

export interface IHeaderProps {
  pageTitle: string;
}

export default function Header(props: IHeaderProps) {
  return (
    <header className="App-header">
      <h1 className="App-title">{props.pageTitle}</h1>
    </header>
  );
}
